import { useMutation, useQueryClient } from 'react-query';
import { createBettieChatRoom, type CreateChatRoomBody, type CreateChatRoomResponse } from '../../../bettie/services/bettieService';

export function useCreateBettieChatRoom() {
  const queryClient = useQueryClient();
  return useMutation<CreateChatRoomResponse, Error, CreateChatRoomBody>(
    (body) => createBettieChatRoom(body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('AllChatRooms');
        queryClient.invalidateQueries('bettieBalances');
      }
    }
  );
}

